import axios from 'axios';
import { INVENTARIO } from './types';
import { changeLoader } from './loader';
import { setAlert } from './alert';

const normalizeNull = (v) => {
    if (v === '' || v === undefined) return null;
    return v;
};

const toUrlEncodedAll = (obj) => {
    const params = new URLSearchParams();
    Object.keys(obj || {}).forEach((k) => {
        params.append(k, obj[k]);
    });
    return params.toString();
};

export const listarInventario = (filtros = {}) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncodedAll({
        id_proveedor: normalizeNull(filtros.id_proveedor),
        id_categoria: normalizeNull(filtros.id_categoria),
        id_subcategoria: normalizeNull(filtros.id_subcategoria),
        nombre: normalizeNull(filtros.nombre),
        codigo_tienda: normalizeNull(filtros.codigo_tienda),
        codigo_proveedor: normalizeNull(filtros.codigo_proveedor),
        status: normalizeNull(filtros.status)
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/inventario/listar`,
            body,
            config
        );
        await dispatch({
            type: INVENTARIO.LISTAR,
            payload: res.data?.productos || []
        });
        await dispatch(changeLoader(false));
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: INVENTARIO.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al listar inventario', 'danger'));
    }
};

export const cargarCategoriasInventario = () => async (dispatch) => {
    try {
        await dispatch(changeLoader(true));
        let res = null;

        try {
            res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/listar_categorias`);
        } catch (e) {
            res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/listar`);
        }

        await dispatch({
            type: INVENTARIO.CATEGORIAS_CARGADAS,
            payload: res.data?.categorias || []
        });
        await dispatch(changeLoader(false));
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: INVENTARIO.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al cargar categorías', 'danger'));
    }
};

export const cargarSubcategoriasInventario = (idCategoria) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncodedAll({ id: idCategoria });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/listar_subcategorias`,
            body,
            config
        );
        await dispatch({
            type: INVENTARIO.SUBCATEGORIAS_CARGADAS,
            payload: res.data?.subcategorias || []
        });
        await dispatch(changeLoader(false));
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: INVENTARIO.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al cargar subcategorías', 'danger'));
    }
};

export const cargarProveedoresInventario = () => async (dispatch) => {
    try {
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/proveedores/listar`);
        await dispatch({
            type: INVENTARIO.PROVEEDORES_CARGADOS,
            payload: res.data?.proveedores || []
        });
        await dispatch(changeLoader(false));
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: INVENTARIO.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al cargar proveedores', 'danger'));
    }
};

export const setFiltrosInventario = (filtros) => async (dispatch) => {
    await dispatch({
        type: INVENTARIO.SET_FILTROS,
        payload: filtros || {}
    });
};

export const limpiarFiltrosInventario = () => async (dispatch) => {
    await dispatch({ type: INVENTARIO.LIMPIAR_FILTROS });
};

export const cargarDetallesInventario = (idProducto) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const params = new URLSearchParams();
    params.append('id', idProducto);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/inventario/detalles`,
            params.toString(),
            config
        );
        await dispatch({
            type: INVENTARIO.DETALLES,
            payload: res.data?.producto || null
        });
        await dispatch(changeLoader(false));
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: INVENTARIO.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al consultar detalles de inventario', 'danger'));
    }
};

export const limpiarDetallesInventario = () => async (dispatch) => {
    await dispatch({ type: INVENTARIO.LIMPIAR_DETALLES });
};

export const cargarProveedoresProductoInventario = (idProducto) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const params = new URLSearchParams();
    params.append('id', String(idProducto || ''));

    try {
        await dispatch({ type: INVENTARIO.PROVEEDORES_PRODUCTO_CARGANDO });
        await dispatch(changeLoader(true));

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/proveedores_producto`,
            params.toString(),
            config
        );

        await dispatch({
            type: INVENTARIO.PROVEEDORES_PRODUCTO_CARGADOS,
            payload: Array.isArray(res?.data?.productos) ? res.data.productos : []
        });

        await dispatch(changeLoader(false));
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: INVENTARIO.PROVEEDORES_PRODUCTO_ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al consultar proveedores del producto', 'danger'));
    }
};

export const limpiarProveedoresProductoInventario = () => async (dispatch) => {
    await dispatch({ type: INVENTARIO.LIMPIAR_PROVEEDORES_PRODUCTO });
};

///Movimientos

export const listarMovimientosInventario = () => async (dispatch) => {
    try {
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/movimientos/listar`);
        await dispatch({
            type: INVENTARIO.MOVIMIENTOS_LISTAR,
            payload: res.data?.movimientos || []
        });
        await dispatch(changeLoader(false));
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: INVENTARIO.MOVIMIENTOS_ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al listar movimientos', 'danger'));
    }
};

export const limpiarMovimientosInventario = () => async (dispatch) => {
    await dispatch({ type: INVENTARIO.MOVIMIENTOS_LIMPIAR });
};

export const cargarAreasMovimientos = () => async (dispatch) => {
    try {
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/listar_areas`);
        await dispatch({
            type: INVENTARIO.MOVIMIENTOS_AREAS_CARGADAS,
            payload: res.data?.areas || []
        });
        await dispatch(changeLoader(false));
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: INVENTARIO.MOVIMIENTOS_ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al cargar áreas', 'danger'));
    }
};

export const cargarOrganizadoresMovimientos = (idArea, tipo = 'origen') => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncodedAll({ id: normalizeNull(idArea) });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/listar_organizadores`,
            body,
            config
        );

        const type = (tipo === 'destino')
            ? INVENTARIO.MOVIMIENTOS_ORGANIZADORES_DESTINO_CARGADOS
            : INVENTARIO.MOVIMIENTOS_ORGANIZADORES_ORIGEN_CARGADOS;

        await dispatch({
            type,
            payload: res.data?.organizadores || []
        });

        const typeUbi = (tipo === 'destino')
            ? INVENTARIO.MOVIMIENTOS_UBICACIONES_DESTINO_CARGADAS
            : INVENTARIO.MOVIMIENTOS_UBICACIONES_ORIGEN_CARGADAS;

        await dispatch({
            type: typeUbi,
            payload: []
        });

        await dispatch(changeLoader(false));
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: INVENTARIO.MOVIMIENTOS_ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al cargar organizadores', 'danger'));
    }
};

export const cargarUbicacionesMovimientos = (idOrganizador, tipo = 'origen') => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncodedAll({ id: normalizeNull(idOrganizador) });

    try {
        await dispatch(changeLoader(true));

        if (!idOrganizador) {
            const type = (tipo === 'destino')
                ? INVENTARIO.MOVIMIENTOS_UBICACIONES_DESTINO_CARGADAS
                : INVENTARIO.MOVIMIENTOS_UBICACIONES_ORIGEN_CARGADAS;

            await dispatch({ type, payload: [] });
            await dispatch(changeLoader(false));
            return;
        }

        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/configuracion/listar_ubicaciones`,
            body,
            config
        );

        const type = (tipo === 'destino')
            ? INVENTARIO.MOVIMIENTOS_UBICACIONES_DESTINO_CARGADAS
            : INVENTARIO.MOVIMIENTOS_UBICACIONES_ORIGEN_CARGADAS;

        await dispatch({
            type,
            payload: res.data?.ubicaciones || []
        });
        await dispatch(changeLoader(false));
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: INVENTARIO.MOVIMIENTOS_ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al cargar ubicaciones', 'danger'));
    }
};

export const listarProductosMovimientos = ({ id_area, id_organizador, id_ubicacion }) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncodedAll({
        id_area: normalizeNull(id_area),
        id_organizador: normalizeNull(id_organizador),
        id_ubicacion: normalizeNull(id_ubicacion)
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/movimientos/listar_productos`,
            body,
            config
        );

        await dispatch({
            type: INVENTARIO.MOVIMIENTOS_PRODUCTOS_ORIGEN_CARGADOS,
            payload: res.data?.productos || []
        });

        await dispatch(changeLoader(false));
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: INVENTARIO.MOVIMIENTOS_ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al listar productos de la ubicación', 'danger'));
    }
};

export const limpiarFormMovimientos = ({ keepAreas = false, keepDestino = false } = {}) => async (dispatch, getState) => {
    const state = getState()?.inventario || {};
    const areas = keepAreas ? (state.movimientosAreas || []) : [];

    await dispatch({
        type: INVENTARIO.MOVIMIENTOS_LIMPIAR_FORM,
        payload: {
            keepAreas,
            keepDestino,
            areas
        }
    });
};

export const crearMovimientoInventario = (payload = {}) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncodedAll({
        id_producto: normalizeNull(payload.id_producto),
        cantidad: normalizeNull(payload.cantidad),
        conversion: normalizeNull(payload.conversion),
        id_unidad: normalizeNull(payload.id_unidad),
        id_area_origen: normalizeNull(payload.id_area_origen),
        id_organizador_origen: normalizeNull(payload.id_organizador_origen),
        id_ubicacion_origen: normalizeNull(payload.id_ubicacion_origen),
        id_area_destino: normalizeNull(payload.id_area_destino),
        id_organizador_destino: normalizeNull(payload.id_organizador_destino),
        id_ubicacion_destino: normalizeNull(payload.id_ubicacion_destino)
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/movimientos/crear`,
            body,
            config
        );

        await dispatch({ type: INVENTARIO.MOVIMIENTOS_CREADO });
        await dispatch(changeLoader(false));

        if (res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'Movimiento creado correctamente', 'success'));
            return true;
        }

        dispatch(setAlert(res.data?.msg || 'No se pudo crear el movimiento', 'danger'));
        return false;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: INVENTARIO.MOVIMIENTOS_ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al crear movimiento', 'danger'));
        return false;
    }
};